import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, arrayRemoveAll, arrayPush } from 'redux-form';
import SelectField from './SelectField';

class SalaryTypeSelect extends Component {
    constructor(props){
        super(props);
        this.customOnChange = this.customOnChange.bind(this);
    }

    customOnChange(event){
        this.props.dispatch(arrayRemoveAll("IncomesForm", "check_stubs"));
        switch(event.target.value){
            case '0':
                this.props.dispatch(arrayPush("IncomesForm", "check_stubs", {}));
                break;
            case '1':
                this.props.dispatch(arrayPush("IncomesForm", "check_stubs", {}));
                this.props.dispatch(arrayPush("IncomesForm", "check_stubs", {}));
                break;
            default:
                this.props.dispatch(arrayPush("IncomesForm", "check_stubs", {}));
        }
        this.props.input.onChange(event);
    }


    render() {
        let props = Object.assign({}, this.props, {input: {onChange: this.customOnChange }})
        return (<SelectField  {...props} />);
    }
}


const selector = formValueSelector('IncomesForm')

SalaryTypeSelect = connect(
    state => {
        const salary_type = selector(state, 'salary_type')
        return {
            salary_type
        }
    }
)(SalaryTypeSelect)

export default SalaryTypeSelect;


/** WEBPACK FOOTER **
 ** ./src/components/SalaryTypeSelect.js
 **/